/**
 * The admin's plain tables, in its own spacing and rules. They sit on the page's own background
 * (#f1f1f1), not a card, so the row rules are the admin's border gray rather than the page's.
 */
export const TABLE = { width: "100%", borderCollapse: "collapse" } as const;
export const TH = {
  textAlign: "left",
  fontWeight: 600,
  padding: "8px",
  borderBottom: "1px solid #d4d4d4",
} as const;
export const TD = {
  padding: "8px",
  borderBottom: "1px solid #e3e3e3",
  verticalAlign: "middle",
} as const;
